export default __webpack_public_path__ + "static/logo-soc2-7fe342f611fa62a76bb2dfeb6687d7b6.webp";